import { render } from "./DinoHappy.vue?vue&type=template&id=c7ab79d6"
import script from "./DinoHappy.vue?vue&type=script&lang=js"
export * from "./DinoHappy.vue?vue&type=script&lang=js"
script.render = render

export default script